import { NavigationContainerRefWithCurrent, useNavigation } from '@react-navigation/native'
import { IS_WEB } from 'constants/platform'
import React from 'react'

import { Box } from 'widgets/Box'

import { links } from 'utils/constants'

import { useCreatePostModal } from 'contexts/CreatePostModalContext'

import { EmojiButton } from './subcomponents/EmojiButton'

export const PostTypeSelection = ({
  drawerNavigationRef,
}: {
  drawerNavigationRef: NavigationContainerRefWithCurrent<ReactNavigation.RootParamList>
}) => {
  const navigation = useNavigation<any>()
  const createPostModalRef = useCreatePostModal()

  return (
    <Box testID='PostTypeSelectionPage' flexDirection='column' backgroundColor='white' flex={1}>
      <Box
        testID='CreatePostContent'
        padding={{ top: !IS_WEB ? 'sm' : undefined }}
        flexDirection='row'
        width='100%'
        justifyContent='center'
      >
        <EmojiButton
          emoji={'\u{1F3C3}'}
          title={'Share\nActivity'}
          subtitle={'you do outside\nthe app'}
          onPress={() => {
            createPostModalRef?.current?.snapToIndex(1)
            navigation.navigate(links.ACTIVITY_GROUP_SELECTION_PAGE)
          }}
        />
        <EmojiButton
          emoji={'\u{1F4F8}'}
          title={'Create\nPost'}
          subtitle={'add text, image,\nor video'}
          onPress={() => {
            createPostModalRef?.current?.dismiss()
            setTimeout(() => drawerNavigationRef?.current?.navigate(links.CREATE_POST_PAGE), 200)
          }}
        />
        <EmojiButton
          emoji={'\u{1F4AA}'}
          title={'Build\nWorkout'}
          subtitle={'for others to\ncompete'}
          onPress={() => {
            createPostModalRef?.current?.dismiss()
            setTimeout(() => drawerNavigationRef?.current?.navigate(links.CREATE_WORKOUT_PAGE), 200)
          }}
        />
      </Box>
    </Box>
  )
}
